import { useContext } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ProgressBar from "../ProgressBar/ProgressBar";
import Typography from "../Typography/Typography";
import styles from "./Navbar.module.scss";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";
import { StateContext } from "../../contexts/state.context";

const Navbar = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { formData } = useContext(StateContext);

	const handleBackClick = () => {
		switch (pathname) {
			case "/register/validate-identity":
				navigate("/");
				break;

			case "/register/personal-data":
				// Flujo POS: vuelve a "Identifícate", no al paso 1 del
				// registro tradicional (que borra los datos precargados).
				navigate(
					formData?.fromPos
						? "/complete-register"
						: "/register/validate-identity",
				);
				break;

			case "/register/last-steps":
				navigate("/register/personal-data");
				break;

			default:
				navigate();
				break;
		}
	};

	return (
		<div className={styles.navbarContainer}>
			<div className={styles.navbarTitleContainer}>
				<ArrowLeft
					className={styles.navbarTitleArrow}
					onClick={handleBackClick}
				/>

				<div
					className={styles.navbarTitleTxt}
					style={{ margin: "17px" }}
				>
					<Typography variant="h5">
						Únete a Amigos Juan Valdez
					</Typography>
				</div>
			</div>

			<div className={styles.navbarProgressBarContainer}>
				<ProgressBar></ProgressBar>
			</div>
			<Outlet />
		</div>
	);
};

export default Navbar;
